import { message } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import { RunSummaryTable } from '../../components/summary/runs_summary_table';
import { selectColormap } from '../../features/analysisConfig/analysisConfigSlice';
import { fetchAuthorizedAPIEndpoint } from '../../utils';
import { useAuth0 } from '@auth0/auth0-react';
import { RunMetadata } from '../../types/runsType';

export const SessionRunsTable: FC<{ sessionID: string }> = (props) => {
  const { sessionID } = props;

  const { getAccessTokenSilently } = useAuth0();
  const [accessToken, setAccessToken] = useState<string | undefined>();

  const [runs, setRuns] = useState<RunMetadata[]>([]);
  const cmap = useAppSelector(selectColormap);

  useEffect(() => {
    getAccessTokenSilently().then((token) => {
      setAccessToken(token);
    });
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (!accessToken) return;
    fetchAuthorizedAPIEndpoint(`/runs?session_id=${sessionID}`, accessToken)
      .then((resp) => {
        if (resp.ok) {
          return resp.json();
        } else {
          throw resp.json();
        }
      })
      .catch((e) => {
        e.then((resp: { Reason: string }) => {
          message.error(`Error occured during data digestion in the cloud: ${resp.Reason}`, 5);
        });
        return;
      })
      .then((runs: RunMetadata[]) => {
        runs.forEach((run) => {
          if (run.Tags === null) {
            run.Tags = [];
          }
          if (run.ItemNames === null) {
            run.ItemNames = [];
          }
          if (run.Cycles === null) {
            run.Cycles = [];
          }
        });
        setRuns(runs);
      });
  }, [accessToken, sessionID]);

  return <RunSummaryTable runs={runs} cmap={cmap} drawFooter={false} />;
};
